import gql from "graphql-tag"

const getRecommendations = () => (gql`{ 
    destinationRecommendations {
        isRepeater
        isSwitcher
        previousDestination
        articles {
            id
            header
            teaser
            description
            image {
                url
                caption
                alt
            }
        }
        destinations {
            id
            name
            usp
            image
            siteUrl
        }
    }
}`)

export {
    getRecommendations
}
